if (!customElements.get('cart-form')) {
  customElements.define(
    'cart-form',
    class CartForm extends HTMLElement {
      constructor() {
        super();

        // Bind methods
        this.handleSubmitEvent = this.handleSubmitEvent.bind(this);
        this.popupSelector = this.dataset.selector;
        this.getMainForm = this.getMainForm.bind(this);
        this.getProductId = this.getProductId.bind(this);

        // Initialize properties
        this.form = null;
      }

      connectedCallback() {
        this.form = this.querySelector(`form[action="/cart/add"][role="main"]`);
        if (this.form) {
          this.form.addEventListener('submit', this.handleSubmitEvent);
        }

        this.querySelectorAll('form[action="/cart/add"]:not([role="main"])').forEach((form) => {
          form.addEventListener('submit', this.handleSubmitEvent);
        });

        const variantPickers = this.querySelectorAll('variant-picker');
        for (const picker of variantPickers) {
          picker.boundToCartForm(this);
        }
        const quickAddBottomSheet = this.querySelector('quick-add-bottom-sheet');
        if (quickAddBottomSheet && quickAddBottomSheet.boundToCartForm) {
          quickAddBottomSheet.boundToCartForm(this);
        }

        const quickAddModal = this.querySelector('quick-add-modal');

        if (quickAddModal && quickAddModal.boundToCartForm) {
          quickAddModal.boundToCartForm(this);
        }
      }

      getMainForm() {
        return this.form;
      }

      getProductId() {
        return this.dataset.productId;
      }

      async handleSubmitEvent(evt) {
        Cart.setLoadingCart();
        evt.preventDefault();
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        config.body = formData;
        
        const submitButtons = this.querySelectorAll('button[js-variant-add-to-bag]');
        submitButtons.forEach((submitButton) => {
          submitButton.disabled = true;
          submitButton.classList.add('loading');
        });
        
        const upsellProduct = this.querySelector('.js-upsell-toggle');
        let upsellProductData = ''
        if (upsellProduct) {
          upsellProductData = upsellProduct.checked ? upsellProduct.dataset.productId : '';
        }
        const objFormData = Object.fromEntries(formData)
        
        let items = [];
        if (upsellProductData && upsellProductData != '') {
          items.push(
            {
              id: upsellProductData,
              quantity: 1
            }
          )
        } else {
          items.push(
            {
              id: objFormData.id,
              quantity: 1,
              selling_plan: objFormData.selling_plan
            }
          )
        }

        let finalFormData = {
          items: items
        };

        const res = await fetch(`/cart/add`, {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/javascript",
              "X-Requested-With":"XMLHttpRequest"
            },
            body: JSON.stringify(finalFormData),
        })
        .then(response => response.json())
        // const res = await fetch(`${routes.cart_add_url}`, config).then((response) => response.json());

        Cart.render();
        submitButtons.forEach((submitButton) => {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
        });
        this.dispatchEvent(new CustomEvent('cart-form-submit'));
        Cart.openCartDrawer();
        this.closePopUpModalVariant();
      }

      closePopUpModalVariant() {
        const popup = this.querySelector('quick-add-modal');
        if (!popup) return

        popup.classList.add('closing')
        setTimeout(() => {
          popup.classList.remove('open');
          popup.classList.remove('closing');
        }, 300);
      }
    }
  );
}

class Cart {
  static data = null;

  static getSectionToRenderInitial() {
    return [
      {
        id: 'cart-drawer'
      }
    ]
  }

  static getSectionToRender() {
    return [
      {
        id: 'cart-drawer',
      },
      // {
      //   id: 'cart-drawer-content',
      // },
      {
        id: 'cart-drawer--items--list'
      },
      {
        id: 'cart-drawer--offer-progress-bar',
      },
      {
        id: 'cart-drawer--checkout',
      },
      {
        id: 'cart-drawer--total-quantity',
        target: '.cart-button .cart-item-counter',
      },
      {
        id: 'hidden-product-recommendations',
        outer: true,
      },
      {
        id: 'cart-drawer--auto-add-free-gift-trigger',
        trigger: Cart.tryToAddFreeMysteryBox,
      },
      {
        id: 'cart-drawer--auto-add-rush-order-trigger',
        trigger: Cart.tryToAddRushOrder,
      },
    ];
  }

  static getRecommendations() {
    const sectionsToRenders = [
      {
        id: '#cart-drawer .product-recommendations',
      },
      {
        id: '#cart-drawer .product-recommendations-mobile',
      },
      {
        id: '.modal-product-recommendations-mobile',
      },
      {
        id: '.modal-change-variants'
      }
    ];
    const hiddenSection = document.getElementById('hidden-product-recommendations');
    const url = hiddenSection?.dataset?.url;
    const productId = hiddenSection?.dataset?.productId;
    if (!url || productId == '') return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        for (const section of sectionsToRenders) {
          const source = html.querySelector(section.id);
          const target = document.querySelector(section.id);
          if (source?.innerHTML.trim().length && target?.innerHTML) {
            target.innerHTML = source.innerHTML;
          }
        }
      })
      .catch((e) => {
        console.error(e);
      }).finally(() => {
        this.removeComponentItemsInRecommendations();
        this.initSwiper();
        this.initUpdateVariants();
      })
  }

  static async initSwiper() {
    const swiper = new Swiper('.swiper.product-recommendation-swiper', {
      navigation: {
        nextEl: '.swiper-button-next.product-recommendation-swiper',
        prevEl: '.swiper-button-prev.product-recommendation-swiper',
      },
    });
  }

  static async initUpdateVariants() {
    const radioUpdateVariantInputs = document.querySelectorAll('[js-update-variant-input]');

    radioUpdateVariantInputs.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        if (radio.checked) {
          const defaultVariantId = radio.dataset.defaultVariantId;
          const defaultQuantity = radio.dataset.defaultQuantity;
          const variantId = radio.value;
          this.updateVariant(defaultVariantId, variantId, defaultQuantity);
          window.setLoadingCartItem(e)
        }
      });

      radio.addEventListener('click', (e) => {
        window.closeChangeVariant(radio.dataset.cartItemId);
      })
    })
  }

  static async updateVariant(oldVariantId, newVariantId, quantity) {
    const config = fetchConfig('javascript');
    const updates = {
      [oldVariantId]: 0,
      [newVariantId]: quantity
    }
    config.body = JSON.stringify({
      updates: updates
    });

    await fetch(`${routes.cart_update_url}`, config).then((response) => response.json());
    Cart.render();
  }


  // Remove recommendations that are components of combo items in cart
  static async removeComponentItemsInRecommendations() {
    const cartItems = document.querySelectorAll('[js-cart-product]');
    const recommendations = document.querySelectorAll('[js-cart-recommendation]');

    const cartItemIds = Array.from(cartItems).map((item) => item.dataset.productId);

    const removeItems = [];
    for (const combo of LIST_COMBO_ITEMS) {
      const comboProductIds = combo.comboProductIds;
      const componentProductIds = combo.componentProductIds;

      const isComboInCart = comboProductIds.filter((id) => cartItemIds.includes(id.toString())).length > 0;
      if (isComboInCart) {
        removeItems.push(...componentProductIds);
      }
    }

    for (const recommendation of recommendations) {
      const recommendationId = recommendation.dataset.productId;
      if (removeItems.includes(parseInt(recommendationId))) {
        recommendation.remove();
      }
    }
  }

  static async setLoadingCart() {
    const continueShopping = document.querySelector('.continue-shopping');
    if (continueShopping) {
      continueShopping.classList.add('loading');
    }
  }

  static async render() {
    Cart.setLoadingCart();
    const res = await fetch(`${Shopify.routes.root}?sections=cart-drawer`, fetchConfig('javascript', 'GET')).then(
      (res) => res.json()
    );
    
    const html = new DOMParser().parseFromString(res['cart-drawer'], 'text/html');
    let sectionToRender = Cart.getSectionToRender();

    const bagEmpty = document.querySelector('[js-bag-empty]');
    if (bagEmpty) {
      sectionToRender = Cart.getSectionToRenderInitial();
    }

    for (const section of sectionToRender) {
      const sectionElement = html.getElementById(section.id);
      let target;

      if (section.target) {
        target = document.querySelector(section.target);
      } else {
        target = document.getElementById(section.id);
      }

      if (sectionElement && section.trigger) {
        section.trigger();
      }
      if (sectionElement && !!target) {
        if (section.outer) {
          target.outerHTML = sectionElement.outerHTML;
        } else if (section.target) {
          target.innerHTML = sectionElement.innerHTML;
        } else {
          target.innerHTML = sectionElement.innerHTML;
        }
      }
    }

    // if (!bagEmpty) {
    Cart.getRecommendations();
    // }
  }

  static async addItemToCart(itemId, quantity = 1) {
    const body = JSON.stringify({
      items: [
        {
          id: itemId,
          quantity: quantity,
        },
      ],
    });
    const config = fetchConfig('javascript');
    config.body = body;
    await fetch(`${routes.cart_add_url}`, config).then((response) => response.json());
    Cart.render();
  }

  static async updateCartItemQuantity(itemId, quantity) {
    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
      id: itemId,
      quantity: quantity,
    });
    const res = await fetch(`${routes.cart_change_url}`, config).then((response) => response.json());
    Cart.render();
  }

  static async updateCartItemQuantityByLine(line, quantity) {
    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
      line: Number(line),
      quantity: quantity,
    });
    const res = await fetch(`${routes.cart_change_url}`, config).then((response) => response.json());
    Cart.render();
  }

  static async changeToSubscription(line, quantity, productId, sellingPlanId) {
    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
      line: Number(line),
      quantity: quantity,
    });
    console.log(config.body, "config.body");
    const removeNonSubs = await fetch(`${routes.cart_change_url}`, config);

    if (removeNonSubs.ok) {
      const bodyAdd = JSON.stringify({
        items: [
          {
            id: productId,
            quantity: 1,
            selling_plan: sellingPlanId
          },
        ],
      });

      console.log(bodyAdd, "bodyAdd");

      const configAdd = fetchConfig('javascript');
      configAdd.body = bodyAdd;

      const addSubs = await fetch(`${routes.cart_add_url}`, configAdd);

      if (addSubs.ok) {
        Cart.render();
      } else {
        console.error('Failed to add subscription:', addSubs);
      }
    } else {
      console.error('Failed to remove non-subs:', removeNonSubs);
    }
  }

  static closeCartDrawer() {
    const cartDrawer = document.getElementById('cart-drawer');
    this.allowScrollBody();
    if (cartDrawer) {
      cartDrawer.classList.add('closing');
      setTimeout(() => {
        cartDrawer.classList.remove('closing');
        cartDrawer.classList.remove('active');
      }, 100);
    }

    window.toggleChatBox(true);
  }

  static openCartDrawer() {
    document.body.classList.add('overflow-hidden');
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      this.preventScrollBody();
    }

    window.toggleChatBox(false);
  }

  static preventScrollBody() {
    document.body.classList.add('overflow-hidden');
  }

  static allowScrollBody() {
    document.body.classList.remove('overflow-hidden');
  }

  static closeMysteryGiftDialog() {
    document.getElementById('mystery-box-dialog').classList.add('hidden');
    $.cookie('mystery-box-dialog', 'closed', { expires: new Date(Date.now() + 24 * 3600 * 1000) });
  }

  static openMysteryGiftDialog() {
    document.getElementById('mystery-box-dialog').classList.remove('hidden');
  }

  static autoOpenMysteryGiftDialog() {
    if (!$.cookie('mystery-box-dialog')) {
      Cart.openMysteryGiftDialog();
    }
  }

  static async tryToAddFreeMysteryBox() {
    if (sessionStorage.userDoNotWantFreeMysteryBox === 'yes') {
      return;
    }
    Cart.addItemToCart(window.settings.mystery_gift_variant_id, 1);
  }

  static async tryToAddRushOrder() {
    if (sessionStorage.userDoNotWantRushOrder === 'yes') {
      return;
    }
    Cart.addItemToCart(window.settings.rush_order_variant_id, 1);
  }
}


const LIST_COMBO_ITEMS = [
  {
    comboProductIds: [7779351298206, 7817580642462],
    componentProductIds: [7628577702046, 7779372499102],
  }
]

function toggleChatBox(isShow) {
  const popups = document.querySelectorAll(LIST_HIDDEN_ON_POPUP.join(', '));
  
  if (isShow) {
    popups.forEach(popup => {
      popup.style.display = 'block';
    });
  } else {
    popups.forEach(popup => {
      popup.style.display = 'none';
    });
  }
}

const LIST_HIDDEN_ON_POPUP = [
  '#gorgias-chat-container',
  '#recart-popup-root'
]

window.toggleChatBox = toggleChatBox;
